var parent = require('../es/parse-float');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/parse-float.js
// module id = 2319
// module chunks = 25